const checkVisibility = {
  methods: {
    isVisible(item, data) {
      return this._.isFunction(item.visible) ? item.visible(data) : true
    }
  }
}

export default checkVisibility
